module.exports = __webpack_public_path__ + "assets/img/01-s.029cd0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/01-s.jpg
// module id = D37o
// module chunks = 0